import { DefaultState } from 'store/reducers/types';

export const READ_JOB_LIST_DATA_REQUEST = 'READ_JOB_LIST_DATA_REQUEST';
export const READ_JOB_LIST_DATA_SUCCESS = 'READ_JOB_LIST_DATA_SUCCESS';
export const READ_JOB_LIST_DATA_FAILURE = 'READ_JOB_LIST_DATA_FAILURE';

export type JobListData = any;

export type JobListState = DefaultState & {
  contents?: JobListData;
};

interface ReadJobListDataRequest {
  type: typeof READ_JOB_LIST_DATA_REQUEST;
};

interface ReadJobListDataSuccess {
  type: typeof READ_JOB_LIST_DATA_SUCCESS,
  contents: JobListData;
}

interface ReadJobListDataFailure {
  type: typeof READ_JOB_LIST_DATA_FAILURE;
}

export type JobListActionTypes = ReadJobListDataRequest | ReadJobListDataSuccess | ReadJobListDataFailure;